import {
    LOADING_PRISTINE,
    LOADING_STARTED,
    LOADING_COMPLETED_SUCCESS,
    LOADING_COMPLETED_FAILURE,
    LOAD_EXPORT_USERS_URL,
    SET_EXPORT_USERS_URL_STATE,
} from "../services/constants"
import http from "../services/axios"

const usersModule = {
    state: {
        exportUrlState: {
            state: LOADING_PRISTINE,
            data: null,
            err: null,
        },
    },
    mutations: {
        [SET_EXPORT_USERS_URL_STATE]: (state, payload) => {
            state.exportUrlState = payload;
        },
    },
    actions: {
        [LOAD_EXPORT_USERS_URL]: ({commit, rootState}) => {
            commit(SET_EXPORT_USERS_URL_STATE, {
                state: LOADING_STARTED,
                data: null,
                err: null,
            });

            const url = `api/management/spaces/${rootState.spaceMetadata.id}/users/export`
            return http.post(url)
                .then(results => {
                    if (results.data.success) {
                        commit(SET_EXPORT_USERS_URL_STATE, {
                            state: LOADING_COMPLETED_SUCCESS,
                            data: results.data,
                            err: null,
                        });
                    } else {
                        throw new Error('Issue getting Export Url')
                    }
                }).catch(err => {
                    console.error(err)
                    commit(SET_EXPORT_USERS_URL_STATE, {
                        state: LOADING_COMPLETED_FAILURE,
                        data: null,
                        err: null,
                    });
                })
        },
    }
}

export {usersModule}
